import React from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const languageOptions = [
  { code: "el", flag: "gr", labelKey: "language.greekNative" },
  { code: "en", flag: "gb", labelKey: "language.englishNative" },
];

function LanguageSwitcher({ className = "" }) {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.resolvedLanguage || i18n.language;
  const isCurrentLanguage = (language) => currentLanguage === language || currentLanguage.startsWith(`${language}-`);
  const activeLanguage = languageOptions.find(({ code }) => isCurrentLanguage(code)) || languageOptions[0];

  return (
    <Dropdown
      className={`language-dropdown ${className}`.trim()}
      alignRight
      onSelect={(language) => i18n.changeLanguage(language)}
    >
      <Dropdown.Toggle
        id="language-nav-dropdown"
        variant="link"
        aria-label={`${t("language.selectorLabel")}: ${t(activeLanguage.labelKey)}`}
        title={t("language.selectorLabel")}
      >
        <span className={`fi fi-${activeLanguage.flag}`} aria-hidden="true"></span>
      </Dropdown.Toggle>
      <Dropdown.Menu alignRight aria-labelledby="language-nav-dropdown">
        {languageOptions.map(({ code, labelKey }) => (
          <Dropdown.Item eventKey={code} active={isCurrentLanguage(code)} key={code}>
            {t(labelKey)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default LanguageSwitcher;
